import { List, type RecordOf } from 'immutable';

interface Page {
  rows: Array<any>;
}

interface Payload {
  resources: Array<Page | RecordOf<Page>>;
}

export const upsertReports = (state: any, payload: Payload) => {
  const root = payload.resources[0];
  const rows = payload.resources?.reduce((list, page) => list.concat(page.rows), List().asMutable()).asMutable();
  const newState = state.merge({
    ...(root && 'toJS' in root ? root?.toJS() : root),
    rows,

    isLoading: false,
    error: undefined,
    loadPending: false,
  });
  return newState;
};
